export interface ConsoleLogger {
	debug: (...args: any[]) => void;
	error: (...args: any[]) => void;
	info: (...args: any[]) => void;
	log: (...args: any[]) => void;
	warn: (...args: any[]) => void;
	verbose: (...args: any[]) => void;
}

export const noopLogger: ConsoleLogger = {
	debug: () => {},
	error: () => {},
	info: () => {},
	log: () => {},
	warn: () => {},
	verbose: () => {},
};
